import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'
import { createBaseQueryFile } from '../helper/createBaseQuery'
import { tokenSlice } from '../slice/tokenSlice'

const uploadApi = createApi({
  reducerPath: 'uploadApi',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_FILE_API_URL }),
  tagTypes: ['Upload'],
  endpoints(builder) {
    return {
      uploadFile: builder.mutation({
        query: (data) => {
          data.append('Authorization', `Bearer ${localStorage.getItem('token')}`)
          return {
            url: 'home/upload',
            method: 'POST',
            body: data,
          }
        },

        invalidatesTags: ['Upload'],
      }),
      downloadExcelTemplate: builder.query({
        query: () => {
          return {
            url: `home/module/ImportTemplates/fileName/POImport.xlsm/download`,
            method: 'GET',
          }
        },

        providesTags: ['Upload'],
      }),
    }
  },
})

export const { useUploadFileMutation, useDownloadExcelTemplateQuery } = uploadApi
export { uploadApi }